import { RefObject, useEffect, useLayoutEffect, useMemo, useState } from "react";

let observer: ResizeObserver

// 判断元素是否有溢出
export const useOverflow = <T extends Element>(ref: RefObject<T | null>, deps: [] = []) => {
  const [overflowX, setOverflowX] = useState(false)
  const [overflowY, setOverflowY] = useState(false)
  const overflow = useMemo(() => {
    return overflowX || overflowY
  }, [overflowX, overflowY])


  const computedOverflow = () => {
    if (ref.current) {
      setOverflowY(ref.current.scrollHeight > ref.current.clientHeight)
      setOverflowX(ref.current.scrollWidth > ref.current.clientWidth)
    }

  }
  useLayoutEffect(() => {
    computedOverflow()

    if (!observer) {
      observer = new ResizeObserver(entries => {
        for (const entry of entries) {
          if (entry.target === ref.current) computedOverflow()
        }
      })
    }

    observer.observe(ref.current!)
    return () => {
      observer?.unobserve(ref.current!)
    }
  }, deps)



  return {
    overflowX,
    overflowY,
    overflow
  }
}